import { Injectable } from "@angular/core";
import { CoreService } from "./../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class AreaService {
  constructor(private coreService: CoreService) {}

  list(id: number, page: number = 0, pageSize: number = 0): Observable<any> {
    return this.coreService.get(
      ServiceRoute.area.list + id,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
}
